// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OLpU","content":"styles_content__3MQLK","row":"styles_row__1NIcd","footer":"styles_footer__ow3JQ","phraseLength":"styles_phraseLength__3_wVP"};